module.exports = __webpack_public_path__ + "static/img/3.9d75174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3.png
// module id = igRk
// module chunks = 0